import React from "react";
import { TextInput } from "@opendate-app/setlist";

import { useMarketingSettingsContext } from "../MarketingSettingsIndexContainer";

const NETWORKS = [
  { key: "facebook_url", label: "Facebook", placeholder: "https://www.facebook.com/your-venue" },
  { key: "twitter_url", label: "X (Twitter)", placeholder: "https://www.twitter.com/your-venue" },
  { key: "instagram_url", label: "Instagram", placeholder: "https://www.instagram.com/your-venue" },
  { key: "linkedin_url", label: "LinkedIn", placeholder: "https://www.linkedin.com/your-venue" },
];

const containerStyle = {
  display: "flex",
  flexDirection: "column",
  gap: 16,
  maxWidth: 480,
};

const SocialMediaInputs = () => {
  const {
    formState,
    setFormState,
  } = useMarketingSettingsContext();

  return (
    <div style={containerStyle}>
      {NETWORKS.map((network) => (
        <TextInput
          key={network.key}
          label={network.label}
          type="url"
          value={formState[network.key] || ""}
          onChange={(e) => {
            const { value } = e.target;
            setFormState((prev) => ({
              ...prev,
              [network.key]: value,
            }));
          }}
          placeholder={network.placeholder}
        />
      ))}
    </div>
  );
};

export default SocialMediaInputs;
